module.exports = __webpack_public_path__ + "img/marker-blue.e938bc99.svg";